import { render, staticRenderFns } from "./largeScreen.vue?vue&type=template&id=d18c7756&scoped=true&"
import script from "./largeScreen.vue?vue&type=script&lang=js&"
export * from "./largeScreen.vue?vue&type=script&lang=js&"
import style0 from "./largeScreen.vue?vue&type=style&index=0&id=d18c7756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18c7756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d18c7756')) {
      api.createRecord('d18c7756', component.options)
    } else {
      api.reload('d18c7756', component.options)
    }
    module.hot.accept("./largeScreen.vue?vue&type=template&id=d18c7756&scoped=true&", function () {
      api.rerender('d18c7756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/largeScreen/largeScreen.vue"
export default component.exports